import EventBus from './../wirebox/event-bus'
import jQuery from 'jquery'

//Store original HTML on clone elements
EventBus.subscribe('modules-initialised',  () => {

    const elements = jQuery('.cloneable')
    let element
    
    elements.each((i, elem) => {
        element = jQuery(elem)
        element.data('original', elem.outerHTML)
    })
  
})

//Add clone
jQuery(document).on('click', '.add-clone', (event) => {
    
    const
        clicked = jQuery(event.target),
        original = jQuery(clicked.data('target'))
    
    //Show original if none yet added
    if (original.is(':hidden')) {
        original.show().find('fieldset').prop('disabled', false)
        return
    }
        
    const
        clone = jQuery(original.data('original')),
        target = jQuery(original.data('target')),
        existingClones = target.children(),
        hasExisting = (existingClones.length > 0),
        index = hasExisting ? (parseInt(existingClones.last().data('index')) + 1) : 1,
        prevIndex = hasExisting ? existingClones.first().data('index') : 0

    //Apply index to new clone
    clone.attr('data-index', index)
        
    //Remove unnecessary data from new clone
    clone.attr('id', '').removeClass('cloneable').attr('data-target', '')
        
    //Amend index/ID of new clone inputs
    
    let
        element,
        id
    
    clone.find('input, textarea, select').each((i, elem) => {
        
        element = jQuery(elem)
        
        element.attr('name', element.attr('name').replace('[' + prevIndex + ']', ('[' + index + ']')))
        
        id = element.attr('id')
        if (id) {
            element.attr('id', id.replace('_' + prevIndex, ('_' + index)))
        }
        
        //Reset value
        element.val('')
        
    })
    
    //Amend labels within new clone
    
    let labelFor
    clone.find('label').each((i, elem) => {
        
        element = jQuery(elem)
        labelFor = element.attr('for')
        
        if (labelFor) {
            element.attr('for', id.replace('_' + prevIndex, ('_' + index)))
        }
        
    })
    
    //Remove "disabled" from fieldset
    clone.find('fieldset').prop('disabled', false)
    
    //Append clone to target
    target.append(clone.css('display', '').addClass('clone'))
    clone.trigger('cloned')
        
})

//Delete clone
.on('click', '.delete-clone', (event) => {
    const target = jQuery(event.target).closest('.clone, .cloneable')
    target.is(':first-child') ? target.hide().find('fieldset').prop('disabled', true) : target.remove()
})